import clientAxios from "../config";

const makeFullGame = async (token, data) => clientAxios.post(`/api/game-ganacol`, data, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});
const makePublicGame = async (data) => clientAxios.post(`/api/game-ganacol-public`, data);
const getGamesByUser = async ( token, hits, userUuid, rowsPerPage, page, codeSearch = '', filters = {}) => {
    const cleanCode = (codeSearch ?? '').toString().trim().toUpperCase();

    // path base. userUuid puede ser '0' (admin: todos), un UUID, o vacío.
    let url = `/api/game-ganacol-user/${hits}/${userUuid}/${rowsPerPage}`;

    // tu backend espera el code como segmento adicional (opcional)
    if (cleanCode) url += `/${encodeURIComponent(cleanCode)}`;

    // query params
    const params = new URLSearchParams();
    params.set('page', String(page));

    if (filters?.user_name) params.set('user_name', filters.user_name);
    if (filters?.date_from) params.set('date_from', filters.date_from);
    if (filters?.date_to) params.set('date_to', filters.date_to);
    if (filters?.sort_by) params.set('sort_by', filters.sort_by);
    if (filters?.sort_dir) params.set('sort_dir', filters.sort_dir);

    url += `?${params.toString()}`;

    return clientAxios(url, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const getCountGamesByUser = async (token) => clientAxios(`/api/game-ganacol/user-counter`, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});
const getGameById = async (token, id) => clientAxios(`/api/game-ganacol/${id}`, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});



export {
    makeFullGame,
    getGamesByUser,
    getGameById,
    makePublicGame,
    getCountGamesByUser,
}